export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="px-6 sm:px-8 py-6 border-b border-slate-200 bg-white sticky top-0 z-10" data-testid={testId || "page-header"}>
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-2xl sm:text-3xl font-black tracking-tight text-slate-950" style={{ fontFamily: "Manrope" }}>
            {title}
          </h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>
    </div>
  );
}
